import { useState } from "react";
import { getColorSettings } from "../Utils/helper/commonUtils";
import { Select } from "antd";
import { Typography } from "@mui/material";

export function FloatingLabelSelect({
    label,
    value,
    onChange,
    children,
    placeHolderfontSize = 12,
    style,
    disabled=false,
    renderInput, // <-- new prop
    ...props
}) {
    const [focused, setFocused] = useState(false);

    // Floating if focused or has value
    // console.log('FloatingLabelSelect value', value);
    const isFloating = focused || (Array.isArray(value) ? value.length > 0 : !!value);

    // const localSettingColors = getColorSettings();


    return (
        <div style={{ position: 'relative', width: '100%', ...style }}>
            <Typography
                sx={theme => ({
                    position: 'absolute',
                    fontFamily: 'Inter',
                    left: 12,
                    top: isFloating ? -10 : '50%',
                    transform: isFloating ? 'none' : 'translateY(-50%)',
                    fontSize: isFloating ? 10 : placeHolderfontSize,
                    color: isFloating ? (theme.palette.secondary.orange || theme.palette.primary.primary_shade) : '#000',
                    fontWeight: 300,
                    // lineHeight: '115%',
                    background: '#fff',
                    px: 0.5,
                    zIndex: 2,
                    transition: 'all 0.2s cubic-bezier(.25,.8,.5,1)',
                    pointerEvents: 'none',
                    '& .MuiOutlinedInput-root': {
									'& fieldset': {
										borderColor: theme.palette.secondary.orange || theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'&:hover fieldset': {
										borderColor: theme.palette.secondary.orange || theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'&.Mui-focused fieldset': {
										borderColor: theme.palette.secondary.orange || theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'& .MuiInputBase-input': {
										paddingTop: '7.5px',
										paddingBottom: '7.5px',
									},
								},
                })}
            >
                {label}
            </Typography>
            {renderInput ? (
                renderInput()
            ) : (
                <Select
                    {...props}
                    value={value}
                    disabled={disabled}
                    className='custom-select'
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    onChange={onChange}
                    style={{
                        width: '100%',
                        borderRadius: 10,
                        color : '#000',
                        // backgroundColor: '#fff',
                        ...props.selectStyle,
                    }}
                    dropdownStyle={{ zIndex: 1300 , color: '#000' }}
                >
                    {children}
                </Select>
            )}
        </div>
    );
}